var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4497 7.12477C11.4497 7.77454 11.1916 8.39769 10.7322 8.85715C10.2727 9.31661 9.64954 9.57473 8.99977 9.57473C8.35 9.57473 7.72684 9.31661 7.26738 8.85715C6.80792 8.39769 6.5498 7.77454 6.5498 7.12477C6.5498 6.475 6.80792 5.85184 7.26738 5.39238C7.72684 4.93292 8.35 4.6748 8.99977 4.6748C9.64954 4.6748 10.2727 4.93292 10.7322 5.39238C11.1916 5.85184 11.4497 6.475 11.4497 7.12477V7.12477Z",
    stroke: "current",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1248 7.1249C15.1248 12.9574 8.9999 16.3123 8.9999 16.3123C8.9999 16.3123 2.875 12.9574 2.875 7.1249C2.875 5.50048 3.5203 3.94258 4.66894 2.79394C5.81758 1.6453 7.37548 1 8.9999 1C10.6243 1 12.1822 1.6453 13.3309 2.79394C14.4795 3.94258 15.1248 5.50048 15.1248 7.1249V7.1249Z",
    stroke: "current",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaces);
export default __webpack_public_path__ + "static/media/places.18ae661b90141ebaf31f82ff38b7609c.svg";
export { ForwardRef as ReactComponent };